import { GYPSUM } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { mainBreakpoints } from '../components/common/ProductInfoContainer';
import { HC0124_UPGRADE_HERO_BANNER } from '../constants/ErrorBoundaryNames';
import { withErrorBoundary } from './ErrorBoundary';
import HC0124UpgradeConfigContent from './HC0124UpgradeConfigContent';
import { jsx as _jsx } from "react/jsx-runtime";
const HeroBackground = styled.div.attrs({
  role: 'banner'
}).withConfig({
  displayName: "HC0124UpgradeHeroBanner__HeroBackground",
  componentId: "lq4axa-0"
})(["width:100%;z-index:-1;background-color:", ";"], GYPSUM);
const ContentContainer = styled.div.withConfig({
  displayName: "HC0124UpgradeHeroBanner__ContentContainer",
  componentId: "lq4axa-1"
})(["", ""], mainBreakpoints);
const HC0124UpgradeHeroBanner = ({
  upgradePointApiName,
  upgradeConfig,
  purchaseMotions,
  handlePurchaseMotionButtonClick
}) => {
  return /*#__PURE__*/_jsx(HeroBackground, {
    children: /*#__PURE__*/_jsx(ContentContainer, {
      className: "m-x-auto",
      children: /*#__PURE__*/_jsx(HC0124UpgradeConfigContent, {
        upgradePointApiName: upgradePointApiName,
        upgradeConfig: upgradeConfig,
        purchaseMotions: purchaseMotions,
        handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick
      })
    })
  });
};
export default withErrorBoundary(HC0124UpgradeHeroBanner, {
  boundaryName: HC0124_UPGRADE_HERO_BANNER,
  redirectCallback: () => '/'
});